import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fiber',
  templateUrl: './fiber.component.html',
  styleUrls: ['./fiber.component.css']
})
export class FiberComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
